export default __webpack_public_path__ + "static/media/smallInfoSymbol.07c85444.svg";